  <div *ngIf="isLoading">
    <loading-spinner></loading-spinner>
  </div>

  <div *ngIf="!isLoading">

    <div class="content__holder">
      <h2 class="heading">Admin: Forms</h2>

        <table>
          <thead>
            <tr>
              <th class="width-icon"></th>
              <th class="width-fill">Name</th>
              <th class="width-10">Status</th>
              <th class="width-10">Created On</th>
              <th class="width-10">Type</th>
              <th class="width-10">Question Groups</th>
              <th class="width-10">Threshold Score</th>
              <th class="width-edit">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let form of formsList">
              <td class="width-icon"></td>
              <td class="width-fill">
                <span class="mobile-title">Name: </span>
                {{form.name}}
              </td>
              <td class="width-10">
                <span class="mobile-title">Status: </span>
                <!--<input type="checkbox" [attr.checked]="getReferralFormActive(form) ? 'checked' : null"/>-->
                <span [class]="getReferralFormActive(form) ? 'active' : 'inactive'">
                  {{getReferralFormActive(form) ? 'Active' : 'Inactive'}}
                </span>
              </td>
              <td class="width-10">
                <span class="mobile-title">Created On: </span>
                {{form.createdOn | date: 'dd/MM/yyyy hh:mm:ss a'}}
              </td>
              <td class="width-10">
                <span class="mobile-title">Type: </span>
                {{getReferralFormTypeName(form.referralFormTypeId)}}
              </td>
              <td class="width-10">
                <span class="mobile-title">Question Groups: </span>
                {{form.referralFormQuestionGroups.length || '0'}}
              </td>
              <td class="width-10">
                <span class="mobile-title">Threshold Score: </span>
                {{form.thresholdScore}}
              </td>
              <td class="width-edit actions">
                <a class="button--edit">
                  <span class="mobile-title">Edit:</span>
                  <i class="material-icons" title="Edit" (click)='edit(form.referralFormId)'>edit</i>
                </a>
                <a class="button--view">
                  <span class="mobile-title">Preview:</span>
                  <i class="material-icons" title="Preview" (click)='preview(form.referralFormId)'>visibility</i>
                </a>
                <a class="button--delete">
                  <span class="mobile-title">Delete:</span>
                  <i class="material-icons form-edit__delete-icon" (click)="delete(form.referralFormId, form.name)">delete</i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
    </div>

    <div class="button__row">
      <div></div>
      <a class="button--box blue add" (click)="create()">Create New Form</a>
    </div>

  </div>
